export default __webpack_public_path__ + "static/B0075-ac5756a186ae599998056e342f04bef6.png";